import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import { Grid, Divider, Container, Typography, Breadcrumbs } from '@mui/material';
// import EventListSection from '../sections/_dashboard/EventListSection';
import EventScoreOverviewSection from "../components/app/EventScoreOverviewSection";
import { InfoApi } from "../api/InfoApi";


// ----------------------------------------------------------------------

export default function EventOverviewPage() {
  const { eventId } = useParams();
  const theme = useTheme();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    loadEvent();
  }, [eventId]);

  const loadEvent = async () => {
    const result = await InfoApi.getEventList();
    if (result) {
      const found = result.find((e) => String(e.id) === String(eventId));
      setEvent(found || null);
    }
  };

  return (
    <>
      <title> Event Overview </title>


      <Container maxWidth="xl">
        <Breadcrumbs aria-label="breadcrumb">
          <Typography color="text.primary">Home</Typography>
        </Breadcrumbs>

        <Typography variant="h4" sx={{ mb: 5 }}>
          活動成績總覽
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            {
              event && <EventScoreOverviewSection event={event} />
            }
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
